import { type FC } from "react";
import * as styles from "./styles.css";

export const RequiredLabel: FC = () => <span className={styles.label}>必須</span>;
